import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, model, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatTabsModule} from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';
import { AllStatus } from '../../../core/services/status/all-status';
import { ProgressPlayerHelper } from '../../../features/progress-player/progress-player-helper';
import { Downtime } from '../../../core/services/times/downtime';
import { DowntimeWindow } from '../../../shared/dialogs/downtime-window/downtime-window';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExitService } from '../../../core/services/exit/exit.service';
import { Subscription, timer } from 'rxjs';
import { InfoFullRoom } from '../../../shared/dialogs/info-full-room/info-full-room';
import { ConfigurationService } from '../../../core/services/configs/configuration';

@Component({
  selector: 'app-step-one',
  imports: [TranslatePipe, MatCheckboxModule, FormsModule, MatTabsModule], //Experiment
  templateUrl: './step-one.html',
  styleUrl: './step-one.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepOne implements OnInit, OnDestroy{

  // @ViewChild('blockDescrGame') blockElem: ElementRef;
  elementRef = inject(ElementRef);
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  allStatus$ = inject(AllStatus);
  subscription: Subscription;
  progressHelper = inject(ProgressPlayerHelper);
  checked = model(false);
  readonly dialog = inject(MatDialog);
  exit = inject(ExitService);
  downtime = inject(Downtime);
  matDialog =  inject(MatDialog);

  configuration = inject(ConfigurationService);

  whenRefresh$ = timer(0, 1000);
  subscriptionTwo: Subscription;

  protected selectedTabIndex = 0;

  constructor( private ref: ChangeDetectorRef){}


  ngOnInit(): void {
    setTimeout(()=>{
      
      if(!this.configuration.configuration?.config?.is_demo){       
        this.progressHelper.getWithStorage();
      }
      this.allStatus$.textSpinner = '';
      this.allStatus$.setDisplayProgressSpinner(false);
      //console.clear();
    },1500);
    
    if(this.allStatus$.isEditUserInWaiting){
      this.allStatus$.isEditUserInWaiting = false;
    }
    this.matDialog.closeAll();
    if(this.allStatus$.openFooter.value){
      this.allStatus$.setOpenFooter(false);
    }
    this.allStatus$.setOpenFooter(false);
    if(this.allStatus$.fullRoom()){
      const dialogConfig = new MatDialogConfig();
      dialogConfig.panelClass = 'nutri-templs';
      dialogConfig.backdropClass = 'nutri-templs-backdrop';
      this.allStatus$.textSpinner = '';
      this.allStatus$.setDisplayProgressSpinner(false);                
      const dialogRef = this.dialog.open(InfoFullRoom, dialogConfig);
      this.allStatus$.fullRoom.set(false);
    }

    this.clearSession();

    this.subscription = this.allStatus$.downTime$.subscribe((follow: any)=>{
      if(follow){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'nutri-templs';
        dialogConfig.backdropClass = 'nutri-templs-backdrop';

        const dialogRef = this.dialog.open(DowntimeWindow, dialogConfig);
        dialogRef.afterClosed().subscribe(result=>{
            this.exit.exitSystem();
        });
      }
    });
    this.updateAllInfo();
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionTwo){
      this.subscriptionTwo.unsubscribe();
    }
  }

  clearSession() {
    sessionStorage.removeItem('QuestInfo');
    sessionStorage.removeItem('player');
    sessionStorage.removeItem('Fields');
  }

  goToCreateGame(){
    this.downtime.refreshTimer();
    this.router.navigate(['/create-game', {view: 'one-player'}]);
  }

  goToStepTwo(){
    this.downtime.refreshTimer();
    this.router.navigate(['/step-two']);
  }

  goToNextRoom():void{
    
    if(this.selectedTabIndex){
      this.goToStepTwo();
    }else{
      this.goToCreateGame();
    }
  }

  updateAllInfo(){
    this.subscriptionTwo = this.whenRefresh$.subscribe(()=>{
      this.ref.markForCheck();
    })
  }

  blockMinHeight():number{ 
    return this.elementRef.nativeElement.querySelector('#blockDescrGame').clientHeight || 80;
  }

}
